// extracted by mini-css-extract-plugin
export default {"actions":"Table_actions__MCpio"};